import { render } from "./NewListDialog.vue?vue&type=template&id=36bd9d22&scoped=true"
import script from "./NewListDialog.vue?vue&type=script&lang=js"
export * from "./NewListDialog.vue?vue&type=script&lang=js"

import "./NewListDialog.vue?vue&type=style&index=0&id=36bd9d22&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nexty-frontend/nexty-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36bd9d22"]])

export default __exports__